export default function isBoltFDSUPanel(projectTypeGUID) {
  return projectTypeGUID === 'b971859d-7e3e-4837-b909-ad078877e95d';
}
